import React, { useState } from "react";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { turnoMap, CreateUserDto } from "../../../service/types/types";
import { UserService } from "../../../service/users.service";
import { useNavigate } from "react-router-dom";

interface Props {
  user: CreateUserDto;
  refreshUser: () => Promise<void>;
}


export default function UpdateUser({user, refreshUser}: Props) {
  const [formData, setFormData] = useState<CreateUserDto>({
  rut: user.rut,
  name: user.name,
  apellido_paterno: user.apellido_paterno,
  apellido_materno: user.apellido_materno,
  fecha_nacimiento: user.fecha_nacimiento,
  sexo: user.sexo,
  comuna: user.comuna,
  provincia: user.provincia,
  region: user.region || "",
  estado_civil: user.estado_civil || "",
  nivel_educacion: user.nivel_educacion || "",
  numero_cargas: user.numero_cargas || 0,
  afp: user.afp || "",
  no_calzado: user.no_calzado || 0,
  talla: user.talla || "",
  fecha_ingreso: user.fecha_ingreso || "",
  sueldo: user.sueldo || 0,
  bonos: user.bonos || 0,
  phone: user.phone || "",
  email: user.email || "",
  direccion: user.direccion || "",
  cargo: user.cargo || "",
  jornada: user.jornada || "",
  contrato: user.contrato || "",
  prevision: user.prevision || "",
  password: user.password || "",
  turno: user.turno || "",
});
  const navigate = useNavigate();



  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    try {
      await UserService.update(formData.rut, formData);
      alert("Usuario actualizado exitosamente");
      refreshUser();
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Error actualizando usuario: " + (error as any)?.message || "Error desconocido");
      return;
    }
  };

  return (
    <div className="w-100 min-vh-100 bg-light p-3">
      <Container fluid className="p-4 bg-white shadow rounded" >
        <h2 className="mb-4">Crear Usuario</h2>
        <Form onSubmit={handleSubmit} className="w-100">
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>RUT *</Form.Label>
                <Form.Control
                  type="text"
                  name="rut"
                  value={formData.rut}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nombre *</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Apellido Paterno</Form.Label>
                <Form.Control
                  type="text"
                  name="apellido_paterno"
                  value={formData.apellido_paterno}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Apellido Materno</Form.Label>
                <Form.Control
                  type="text"
                  name="apellido_materno"
                  value={formData.apellido_materno}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Fecha Nacimiento</Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_nacimiento"
                  value={formData.fecha_nacimiento}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Sexo</Form.Label>
                <Form.Select
                  name="sexo"
                  value={formData.sexo}
                  onChange={handleChange}
                >
                  <option value="">Seleccione</option>
                  <option value="M">Masculino</option>
                  <option value="F">Femenino</option>
                  <option value="O">Otro</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Teléfono *</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label>Dirección</Form.Label>
            <Form.Control
              type="text"
              name="direccion"
              value={formData.direccion}
              onChange={handleChange}
            />
          </Form.Group>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Estado Civil</Form.Label>
                <Form.Control
                  type="text"
                  name="estado_civil"
                  value={formData.estado_civil}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nivel Educación</Form.Label>
                <Form.Control
                  type="text"
                  name="nivel_educacion"
                  value={formData.nivel_educacion}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Talla</Form.Label>
                <Form.Control
                  type="text"
                  name="talla"
                  value={formData.talla}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>N° Calzado</Form.Label>
                <Form.Control
                  type="number"
                  name="no_calzado"
                  value={formData.no_calzado}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>        
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Fecha Ingreso</Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_ingreso"
                  value={formData.fecha_ingreso}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group className="mb-3">
                <Form.Label>Turno *</Form.Label>
                    <Form.Select
                    name="turno"
                    value={formData.turno}
                    onChange={handleChange}
                    required
                    >
                    <option value="">Seleccione un turno</option>
                    {Object.entries(turnoMap).map(([key, label]) => (
                        <option key={key} value={key}>
                        {label}
                        </option>
                    ))}
                    </Form.Select>
                </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Comuna</Form.Label>
                <Form.Control
                  type="text"
                  name="comuna"
                  value={formData.comuna}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Provincia</Form.Label>
                <Form.Control
                  type="text"
                  name="provincia"
                  value={formData.provincia}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Región</Form.Label>
                <Form.Control
                  type="text"
                  name="region"
                  value={formData.region}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Cargo</Form.Label>
                <Form.Control
                  type="text"
                  name="cargo"
                  value={formData.cargo}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Jornada</Form.Label>
                <Form.Control
                  type="text"
                  name="jornada"
                  value={formData.jornada}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Contrato</Form.Label>
                <Form.Control
                  type="text"
                  name="contrato"
                  value={formData.contrato}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Previsión</Form.Label>
                <Form.Control
                  type="text"
                  name="prevision"
                  value={formData.prevision}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>AFP</Form.Label>
                <Form.Control
                  type="text"
                  name="afp"
                  value={formData.afp}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Número de Cargas</Form.Label>
                <Form.Control
                  type="number"
                  name="numero_cargas"
                  value={formData.numero_cargas}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Sueldo</Form.Label>
                <Form.Control
                  type="number"
                  name="sueldo"
                  value={formData.sueldo}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Bonos</Form.Label>
                <Form.Control
                  type="number"
                  name="bonos"
                  value={formData.bonos}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Button variant="primary" type="submit" className="w-100 mt-3">
            Editar Usuario
          </Button>
        </Form>
      </Container>
    </div>
  );
}